import {
  hasUserPermission,
  resolveUserRouteReadPermission,
  USER_ROUTE_READ_PERMISSION,
} from '@glyphic/user-api-types'

import { NAV_ITEMS } from '../layouts/navConfig'

export function isNavRouteAccessible(
  pathname: string,
  permissions: readonly string[],
): boolean {
  return hasUserPermission(permissions, resolveUserRouteReadPermission(pathname))
}

export function getFirstAccessiblePath(permissions: readonly string[]): string {
  for (const item of NAV_ITEMS) {
    if (isNavRouteAccessible(item.to, permissions)) {
      return item.to
    }
  }
  if (hasUserPermission(permissions, undefined)) {
    return '/profile'
  }
  return '/forbidden'
}

export function filterNavByAccess(permissions: readonly string[]) {
  return NAV_ITEMS.filter((item) => isNavRouteAccessible(item.to, permissions))
}

export { USER_ROUTE_READ_PERMISSION }
